














































































































































import tools from "@/tools.coffee"
import StateComments from "@/components/StateComments.vue"
import queries from "@/gql/queries.coffee"
import moment from "moment"
import diff from "diff"
moment.locale("fr")

export default {
    "name": "StateAnswerTextValidation"
    "components": {StateComments}
    "props": {
        "context": {
            "type": Object
            "required": true
        }
        "can_delete": Boolean
        "email_set" : Array
        "review": Object
    }
    "data": ()->
        return {
            "content": null
            "review_lang": null
            "nofr": false
            "show_signature": false
        }
    computed:
        text_history_ordered: ()->
            ret = []
            if @context.data.text_history?
                ret = @context.data.text_history.sort (a, b)->
                    new Date(b.date).getTime() - new Date(a.date).getTime()        
            return ret
        "deeple_translate_link": ()->
            if @content.data.text_fr
                text = @content.data.text_fr\
                    .replace(/&/g, " ")\
                    #.replace(/\n/g, "%0A")\
                    #.replace(/\+/g, "+")\
                    #.replace(/\%/g, "%25")\
                    .replace(/\//g, "∕")
                    
            else
                text = ""
            return 'https://www.deepl.com/translator#fr/en-gb/' + encodeURIComponent(text)
        "human_created_on": ()->
            return moment(@context.created_on).fromNow()
        "hasSentEmail": ()->
            return @email_set.length > 0 && 
                   this.email_set.some(
                       (email) => email.sent_on != null && email.sent_on != ''
                   )
    "methods":
        "modified": (before, after)->
            if not before?
                before = ""
            if not after?
                after = ""
            text_diff = diff.diffWords(before, after)
            out = ""
            for part in text_diff
                if part.added
                    out += '<span style="background-color:#cefacb;">'+part.value+'</span>'
                else if part.removed
                    out += '<span style="background-color:#facbcb;">'+part.value+'</span>'
                else 
                    out += part.value
            return out
        "delete_state": ()->
            @$emit("state:delete_state")
        "update_data": (comments)->
            @content.data.comments = comments
            @$emit("state:update_data", @content.data)
        "saveAnswer": ()->
            @$emit("state:update_data", @content.data)
            @$store.commit("delete_edited_fields", {
                key: "text_native"
            })
            @$store.commit("delete_edited_fields", {
                key: "text_fr"
            })
        "set_answer_content": (value)->
            this.content.data.text_fr = value
        "copysig": (signature)->
            vm = this
            if signature.language.code == "FR"
                if @content.data.text_fr == null
                    @content.data.text_fr = ""
                @content.data.text_fr += "\n\n"+signature.content
                copySignature(signature)
            else
                if @review_lang.code == "FR"
                    setTimeout(()->
                        vm.$store.dispatch("notify",{
                            level: "danger",
                            text: "Echec de la copie, cet avis est en français",
                            seconds: 5
                        })
                    ,100) 
                else
                    if @content.data.text_native == null
                        @content.data.text_native = ""
                    @content.data.text_native += "\n\n"+signature.content
                    copySignature(signature)
        "copySignature": (signature, el)->
            text = signature.content
            textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);

            #@$root.$emit('copysig', signature)
            
            this.$store.dispatch("notify",{
                level: "success",
                text: "Copié!",
                seconds: 2
            })
        "closeListener": (e)-> 
            self = @
            if self.$refs.sigTrigger != e.target
                self.show_signature = false
            return
            
    "mounted": ()->
        self = this
        this.$root.state_set_answer_content = this.set_answer_content

        response = await queries.run("gql_query_get_review_lang", [@content.uid])
        if response.ok
            @review_lang = response.body.data.state.review.native_lang
            @nofr = @review_lang.code != "FR"

        #@$root.$on('copysig', (sig)->
        #    self.copysig(sig))
        document.addEventListener('click', self.closeListener, true)
    "beforeDestroy": ()->
        self = @
        document.removeEventListener('click', self.closeListener, true)                    
    "created": ()->
        self = @
        self.content = tools.deep_copy(self.context)
                
        self.$djangows['onmodelsignals']({"modelName": "state", "appLabel": "state"}, (event)->
            
            if event.obj?
                if event.obj.uid == self.content.uid
                    if event.signal_type == "post_save" and event.created == false
                        self.content.data.comments = event.obj.data.comments
                        self.content.data.text_history = event.obj.data.text_history
        )
                                
    "watch":
        "content.data.text_native": (newV)->
            if this.$refs.answer_native?
                @$store.commit("update_edited_fields", {
                    key: "text_native"
                    value: newV
                    verbose_name: "Réponse traduite"
                    el: this.$refs.answer_native
                })
        "content.data.text_fr": (newV)->
            if this.$refs.answer_fr?
                @$store.commit("update_edited_fields", {
                    key: "text_fr"
                    value: newV
                    verbose_name: "Réponse en francais"
                    el: this.$refs.answer_fr
                })
        #"content.data.text_history": (newV, oldV)->
        #    console.log("text_history", newV)
                
        
}
